
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.8699 13C18.3699 13 17.9599 13.37 17.8899 13.86C17.4099 17.23 14.1199 19.7 10.4699 18.82C8.21995 18.28 6.55995 16.55 6.07995 14.29C5.26995 10.42 8.21995 6.99997 11.9499 6.99997V9.78997C11.9499 10.24 12.4899 10.46 12.7999 10.14L16.5899 6.34997C16.7899 6.14997 16.7899 5.83997 16.5899 5.63997L12.7999 1.84997C12.4899 1.53997 11.9499 1.75997 11.9499 2.19997V4.99997C7.00995 4.99997 3.10995 9.47997 4.10995 14.6C4.70995 17.71 7.00995 20.1 10.0999 20.79C14.9299 21.87 19.2499 18.59 19.8699 14.12C19.9599 13.53 19.4699 13 18.8699 13ZM12.4299 15.15C12.3799 15.22 12.3199 15.28 12.2499 15.32C12.1799 15.36 12.0799 15.38 11.9799 15.38C11.8099 15.38 11.6699 15.33 11.5599 15.23C11.4499 15.13 11.3899 14.99 11.3699 14.82H10.5299C10.5399 15.02 10.5799 15.19 10.6599 15.35C10.7399 15.51 10.8499 15.63 10.9799 15.74C11.1099 15.85 11.2699 15.93 11.4399 15.98C11.6099 16.03 11.7899 16.06 11.9699 16.06C12.2099 16.06 12.4299 16.02 12.6099 15.94C12.7899 15.86 12.9399 15.76 13.0599 15.63C13.1799 15.5 13.2699 15.35 13.3299 15.18C13.3899 15.01 13.4199 14.83 13.4199 14.64C13.4199 14.42 13.3899 14.21 13.3299 14.04C13.2699 13.87 13.1899 13.71 13.0799 13.59C12.9699 13.47 12.8299 13.37 12.6699 13.31C12.5099 13.25 12.3299 13.21 12.1199 13.21C12.0499 13.21 11.9799 13.22 11.9199 13.23C11.8599 13.24 11.7899 13.25 11.7399 13.27C11.6899 13.29 11.6399 13.3 11.5899 13.32C11.5399 13.34 11.5099 13.36 11.4799 13.37L11.5899 12.45H13.2899V11.74H10.8999L10.6499 13.91L11.3199 14.08C11.3499 14.05 11.3799 14.02 11.4199 13.99C11.4599 13.96 11.4899 13.94 11.5399 13.92C11.5899 13.9 11.6399 13.88 11.6899 13.87C11.7399 13.86 11.8199 13.85 11.8899 13.85C12.0099 13.85 12.1099 13.87 12.1899 13.9C12.2699 13.93 12.3499 13.99 12.3999 14.05C12.4499 14.11 12.4999 14.19 12.5299 14.29C12.5599 14.39 12.5699 14.48 12.5699 14.6C12.5699 14.72 12.5599 14.82 12.5399 14.91C12.5199 15 12.4799 15.08 12.4299 15.15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-forward-5`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconForward5

    ```js
    <b-new-b-icon-forward-5 />
    ```
</docs>


